import { TextInput } from "client/Components";
import { IInputAttachable } from "client/Forms/attachable";
import { setTrackingId } from "client/Misc/utils";
import { InputValidationResultKind } from "client/Validation";
import { useEffect, useState } from "react";
import styles from "./EditableListItemContent.module.less";
import { useStableImperativeCallback } from "client/Hooks";

type EditableListItemContentProps = {
	inputAttachable: IInputAttachable<string>;
	initialHasFocus?: boolean;
	onBlur: () => void;
	onToggleEditMode: (isInEditMode: boolean) => void;
};

export const EditableListItemContent = (props: EditableListItemContentProps) => {
	const {
		inputAttachable,
		initialHasFocus = false,
		onBlur,
		onToggleEditMode
	} = props;

	const [itemClickedToggleState, setItemClickedToggleState] = useState<boolean>(initialHasFocus);

	const isTextInputVisible = inputAttachable.validation
		?.getValidationState()
		?.kind === InputValidationResultKind.Invalid || itemClickedToggleState;

	const stableOnToggleEditMode: typeof onToggleEditMode = useStableImperativeCallback(onToggleEditMode);

	useEffect(
		(): void => {
			stableOnToggleEditMode(isTextInputVisible);
		},
		[isTextInputVisible, stableOnToggleEditMode]
	);

	useEffect(
		(): EffectWithDestructorResult => {
			return (): void => stableOnToggleEditMode(false);
		},
		[stableOnToggleEditMode]
	);

	return (
		<div className={styles.editableListItemContentRoot}>
			{isTextInputVisible ? (
				<div {...setTrackingId("editable-list-item-container")} className={styles.editableListInputContainer}>
					<TextInput
						{...inputAttachable.attachToTextInput()
							.withOnBlur(()=>{
								setItemClickedToggleState(false);
								onBlur();
							})
						}
						placeholder="example@example.com"
						attachedOn="right"
						autoFocus="focus"
						height="fill"
					/>
				</div>
			) : (
				<div
					onClick={(e) => {
						e.preventDefault();
						setItemClickedToggleState(true);
					}}
					className={styles.editableListTextContainer}
				>
					{inputAttachable.value}
				</div>
			)}
		</div>
	);
};
EditableListItemContent.displayName = "EditableListItemContent";